export default __webpack_public_path__ + "static/media/block.b3e5e795.png";